require([
	'jquery',
	'masonry',
	'isotope',
], function(
	$,
	Masonry,
	Isotope
	) {

	'use strict';

	function initMasonry(grid) {
		iso = new Isotope( grid, {
		  itemSelector: '.item',
		  masonry: {
		  	precentPosition: true,
			  itemSelector: '.item',
			  columnWidth: '.grid-sizer',
			  gutter: '.grid-gutter'
		  }
		});
	}


	if ($(document).find('.section-Team .js_grid').length > 0) {

		var iso = '';
		var grids = document.querySelectorAll('.js_grid'), i;

		for (i = 0; i < grids.length; ++i) {
		  initMasonry(grids[i]);
		}

		if ($('html').hasClass('touch')) {

			$('.item-small .overlay').click(function(e) {

				if ($(this).hasClass('is_active')) {

					$(this).removeClass('is_active');

				} else {

					e.preventDefault();
					e.stopPropagation();
					$('.overlay').removeClass('is_active');
					$(this).addClass('is_active');

				}
			});
		}

	}
});
define("root/Assets/Templates/Html/Team/Js/Team", function(){});

